import { Box, Typography } from "@mui/material";
import React from "react";
import logo_footer from "../Assets/Images/logo_footer.png";
import green_footer from "../Assets/Images/green_footer.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <Box
        sx={{
          px: "3rem",
          pt: { md: "9rem", xs: "6rem" },
          pb: { md: "7rem", xs: "2rem" },
          backgroundImage: `url(${green_footer})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          // backgroundPosition:"center",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: { md: "10rem", xs: "2rem" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            textAlign: "center",
            flexDirection: "column",
            gap: "10px",
            "& a,span": {
              fontSize: { md: "20px" },
              fontFamily: "centuryGothic !important",
              lineHeight:"normal"
            },
          }}
        >
          <Typography
            component={"img"}
            src={logo_footer}
            sx={{
              width: { md: "300px", xs: "200px"  },
              alignSelf: "center"
            }}
          />
          <span style={{ textAlign: "center" }}>
            <a
              style={{ color: "inherit", textDecoration: "none" }}
              href="mailto:info@capnolearning.org"
            >
              info@CapnoLearning.org
            </a>
          </span>
          <span style={{ textAlign: "center" }}>
          P.O. Box 612, Santa Fe,
          </span>
          <span style={{ textAlign: "center" }}>
           New Mexico, 87506, USA.
          </span>
          <span style={{ textAlign: "center" }}>
          CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup>  provides tele-services.
          </span>

        </Box>
        <Box
          sx={{
            alignSelf: "flex-end",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            "& a": {
              fontSize: "20px",
              fontFamily: "centuryGothic !important",
              mb: "0",
              textAlign: { md: "start", xs: "center" },
              textDecoration: "none",
              color:"#000"
            },
          }}
        >
          <Typography component={Link} to={"/"}>
            Home
          </Typography>
          <Typography component={Link} to={"/service/individual"}>
            Individual services
          </Typography>
          <Typography component={Link} to={"/service/provider"}>
            Provider services
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
